import "./TechStack.css";

const TechStack = () => {
  return (
    <section className="techstack">
      <div className="techstack-container">

        <div className="techstack-header">
          <span className="techstack-tag">TECH STACK</span>
          <h2>
            Technologies We <span>Use</span>
          </h2>
        </div>

        <div className="techstack-grid">

          {/* FRONTEND */}
          <div className="tech-card">
            <h3>Frontend</h3>
            <div className="tech-pills">
              <span>React</span>
              <span>JavaScript</span>
              <span>HTML5</span>
              <span>CSS3</span>
              <span>WordPress</span>
            </div>
          </div>

          {/* BACKEND */}
          <div className="tech-card">
            <h3>Backend & Cloud</h3>
            <div className="tech-pills">
              <span>Node.js</span>
              <span>Firebase</span>
              <span>MongoDB</span>
            </div>
          </div>

          {/* MOBILE */}
          <div className="tech-card">
            <h3>Mobile</h3>
            <div className="tech-pills">
              <span>React Native</span>
            </div>
          </div>

          {/* GAME */}
          <div className="tech-card">
            <h3>Game Development</h3>
            <div className="tech-pills">
              <span>Unity</span>
              <span>C#</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TechStack;
